<div class="d-flex align-items-center">
  @if (!!section.config?.icon) {
    <div class="pe-2 fs-5"><span class="material-symbols-outlined">{{ section.config?.icon }}</span></div>
  }
  <div class="text-uppercase border-end border-gray-300 border-1 pe-2 me-2">{{ section.config?.name }}</div>
  <div class="text-gray-400">{{ resultsShown }} of {{ section.total }} results</div>
  <div class="ms-auto">
    @if (section.config?.showMoreAction === ShowMoreAction.EXPAND && section.results?.length > section.initialCount) {
      <button
        class="btn btn-link"
        (click)="toggle()">See more hits <span class="material-symbols-outlined">arrow_downward</span></button>
    }

    @if (section.config?.showMoreAction === ShowMoreAction.TAB) {
      <button
        class="btn btn-link ms-auto"
        (click)="paramsContainer.setParams({tab: section.config?.tab})">See more hits <span
        class="material-symbols-outlined">arrow_forward</span>
      </button>
    }
  </div>
</div>
<app-search-result-wrapper [results]="section.results | slice : 0 : resultsShown"></app-search-result-wrapper>
